/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {EditAlertConfigModel} from '../../alerts-main-page/models/edit-alert-config.model';

@Component({
    selector: 'app-alert-form-header',
    templateUrl: './alert-form-header.component.html',
    styleUrls: ['./alert-form-header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertFormHeaderComponent {
    @Input() editAlertConfig: EditAlertConfigModel;
    @Input() isViewMode: boolean;
    @Output() closeForm = new EventEmitter<void>();

    getFormTitle(): string {
        let title: string;
        if (this.isViewMode) {
            title = this.editAlertConfig?.editAlertConfigData?.name || '';
        } else {
            title = this.editAlertConfig ? 'Edit Alert' : 'Create Alert';
        }
        return title;
    }
}
